var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { memo, useCallback, useState } from 'react';
import cx from 'classnames';
//stores
import useAccountStore from '@/stores/account';
// components
import MultiSelectBoxNext from '@/components/MultiSelectBox';
import ElementVisibilitySensor from '@/components/ElementVisibilitySensor/ElementVisibilitySensor';
// widgets
import ProductOption from './widgets/ProductOption';
// helpers
import { debounce } from '@/helpers/utils';
// includes
import { fetchProductsApi } from '@/includes/api/products';
// styles
import style from './ProductSearch.module.scss';
function Products({ className, selectedAdGroupCandidates, setAdGroupCandidates, validationMessages, }) {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [nextPageToken, setNextPageToken] = useState('');
    const [query, setQuery] = useState('');
    const { getCurrentAccountId, loggedInAccountDetails } = useAccountStore((state) => ({
        getCurrentAccountId: state.getCurrentAccountId,
        loggedInAccountDetails: state.loggedInAccountDetails,
    }));
    const fetchNextPage = (isVisible) => __awaiter(this, void 0, void 0, function* () {
        if (!isVisible)
            return;
        if (!nextPageToken)
            return;
        const accountId = yield getCurrentAccountId();
        const { advertiserType, advertiserId } = loggedInAccountDetails.account || {};
        const response = yield fetchProductsApi({
            query,
            accountId,
            advertiserType,
            advertiserId,
            nextPageToken,
        });
        if (response) {
            setOptions([...options, ...response.products]);
            setNextPageToken(response.nextPageToken);
        }
    });
    const renderFunction = (option, index, onClick, className) => {
        const jsx = (React.createElement(ProductOption, { className: className, item: option.item, selected: option.selected, onChange: onClick }));
        if (index === options.length - 1) {
            return (React.createElement(ElementVisibilitySensor, { onVisibilityChange: fetchNextPage, senseOnce: true }, jsx));
        }
        else {
            return jsx;
        }
    };
    const onChange = (options) => {
        // populate selectedOptions with correct data
        const newSelectedOptions = [...selectedAdGroupCandidates];
        options.forEach((option) => {
            const matchedItem = selectedAdGroupCandidates.find((item) => item.id === option.item.id);
            if (matchedItem && !option.selected) {
                newSelectedOptions.splice(newSelectedOptions.indexOf(matchedItem), 1);
            }
            if (!matchedItem && option.selected) {
                newSelectedOptions.push({
                    id: option.item.id,
                    attributes: {
                        creativeId: option.item.creativeId,
                        title: option.item.title,
                        description: option.item.description,
                    },
                });
            }
        });
        setAdGroupCandidates(newSelectedOptions);
    };
    const getProducts = (query) => __awaiter(this, void 0, void 0, function* () {
        try {
            if (!query)
                return;
            const accountId = yield getCurrentAccountId();
            const { advertiserType, advertiserId } = loggedInAccountDetails.account || {};
            const products = yield fetchProductsApi({
                query,
                accountId,
                advertiserType,
                advertiserId,
            });
            if (products) {
                setOptions(products.products);
                setNextPageToken(products.nextPageToken);
            }
        }
        catch (error) {
            if (__DEV__) {
                console.log(error);
            }
        }
        finally {
            setIsLoading(false);
        }
    });
    const handleQueryInputChange = (text = '') => {
        setOptions([]);
        setIsLoading(true);
        setQuery(text);
        debouncedGetProducts(text.toLowerCase());
    };
    const debouncedGetProducts = useCallback(debounce(getProducts, 500), []);
    return (React.createElement("div", { className: cx(className, style.inputContainer) },
        React.createElement(MultiSelectBoxNext, { openOnFocus: true, autoUpdatePosition: true, renderFunction: renderFunction, onChange: onChange, values: selectedAdGroupCandidates.map((option) => option.id), options: options, identifier: (item) => item.id, onInputTextChange: handleQueryInputChange, inputErrorText: validationMessages === null || validationMessages === void 0 ? void 0 : validationMessages.candidates, showLoader: isLoading, className: {
                options: style.options,
            } })));
}
export default memo(Products);
